let DistributorsPage = (function () {

    function init()
    {


        const observer = new MutationObserver(() => {
            const header = document.querySelector('.storeify-header-inner');
            if (header) {
                header.style.display = 'none';
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    init();


    return {

    }
})();